import * as THREE from 'three'
import React, { Suspense, useEffect, useState, useRef } from "react"
import { useGLTF, useAnimations } from "@react-three/drei"

export default function Character(props) {

    // Ref
    const ref = useRef()

    // State
    const [start, setStart] = useState(false)

    // Material
    const glowRed = new THREE.MeshBasicMaterial({ color: new THREE.Color(7, 0, 0.5), toneMapped: false })
    const glowGreen = new THREE.MeshBasicMaterial({ color: new THREE.Color(0, 7, 0.5), toneMapped: false })

    const glowOptions = [glowRed, glowGreen];

    const randomNr = Math.floor(Math.random() * glowOptions.length)

    const glow = glowOptions[randomNr]

    // GLB's
    const { scene, nodes, materials, animations } = useGLTF('/mesh/character.glb')

    // Make sure all objects in scene showing while zooming closely
    scene.traverse(function (obj) { obj.frustumCulled = false; });

    // Extract animation actions
    const animation = useAnimations(animations, ref)

    useEffect(() => {
        animation.actions[Object.keys(animation.actions)[0]].getMixer().stopAllAction()
        animation.actions[Object.keys(animation.actions)[0]].play()
    }, [])

    return (
        <>
            <group ref={ref} {...props} dispose={null}>
                <group name="Scene">
                    <group name="Armature" scale={0.01}>
                        <primitive object={nodes.mixamorigHips} />
                        <mesh scale={400} position={[0, 0, 0]} rotation={[-Math.PI / 2, 0, Math.PI / 2.5]}>
                            <ringGeometry args={[0.95, 1, 3, 1]} />
                            <meshStandardMaterial color="white" roughness={0.75} toneMapped={false} />
                        </mesh>
                        <group name="Bril_01">
                            <skinnedMesh name="Circle" geometry={nodes.Circle.geometry} material={glow} skeleton={nodes.Circle.skeleton} />
                            <skinnedMesh name="Circle_1" geometry={nodes.Circle_1.geometry} material={glow} skeleton={nodes.Circle_1.skeleton} />
                        </group>
                        <skinnedMesh name="BrownBody" geometry={nodes.BrownBody.geometry} material={glow} skeleton={nodes.BrownBody.skeleton} />
                        <group name="Circle002">

                            <skinnedMesh name="Circle010" geometry={nodes.Circle010.geometry} material={glow} skeleton={nodes.Circle010.skeleton} />
                            <skinnedMesh name="Circle010_1" geometry={nodes.Circle010_1.geometry} material={glow} skeleton={nodes.Circle010_1.skeleton} />
                            <skinnedMesh name="Circle010_2" geometry={nodes.Circle010_2.geometry} material={glow} skeleton={nodes.Circle010_2.skeleton} />
                            <skinnedMesh name="Circle010_3" geometry={nodes.Circle010_3.geometry} material={glow} skeleton={nodes.Circle010_3.skeleton} />
                            <skinnedMesh name="Circle010_4" geometry={nodes.Circle010_4.geometry} material={glow} skeleton={nodes.Circle010_4.skeleton} />
                            <skinnedMesh name="Circle010_5" geometry={nodes.Circle010_5.geometry} material={glow} skeleton={nodes.Circle010_5.skeleton} />
                            <skinnedMesh name="Circle010_6" geometry={nodes.Circle010_6.geometry} material={glow} skeleton={nodes.Circle010_6.skeleton} />
                        </group>
                        <skinnedMesh name="Glitter_pak_1" geometry={nodes.Glitter_pak_1.geometry} material={glow} skeleton={nodes.Glitter_pak_1.skeleton} />
                        <skinnedMesh name="Haar_01_blond" geometry={nodes.Haar_01_blond.geometry} material={glow} skeleton={nodes.Haar_01_blond.skeleton} />
                        <skinnedMesh name="Ogen_03" geometry={nodes.Ogen_03.geometry} material={glow} skeleton={nodes.Ogen_03.skeleton} />
                        <skinnedMesh name="Oorbellen_2" geometry={nodes.Oorbellen_2.geometry} material={glow} skeleton={nodes.Oorbellen_2.skeleton} />
                        <skinnedMesh name="Wenkbrauw_1" geometry={nodes.Wenkbrauw_1.geometry} material={glow} skeleton={nodes.Wenkbrauw_1.skeleton} />
                    </group>
                </group>
            </group>
        </>
    )
}
